import { Component } from '@angular/core';

@Component({
  selector: 'app-forms-demo',
  templateUrl: './forms-demo.component.html',
})
export class FormsDemoComponent {}
